import ApiService from "../api";

export default class UsuarioVpnService extends ApiService {

    constructor() {
        super('/api/formulario/usuario-vpn')
    }

    enviarFormulario(form) {
        return this.post(`/salvar`, form)
    }

}